import React from 'react';
import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Icon,
  Box
} from '@chakra-ui/react';
import { FaBuilding } from 'react-icons/fa';
import '../../Styles/theme/PasswordModel.css';

const CompanyFormModal = ({
  visible,
  isEditing,
  companyInfo,
  isLoading,
  onInfoChange,
  onSubmit,
  onCancel
}) => {
  if (!visible) return null;

  const handleChange = (field, value) => {
    onInfoChange(field, value);
  };

  return (
    <div className="model-overlay">
      <div className="model" style={{ width: '500px', maxWidth: '90%' }}>
        <Box display="flex" alignItems="center" marginBottom="20px">
          <Icon as={FaBuilding} boxSize={6} color="#1C734A" mr={3} />
          <Box fontWeight="bold" fontSize="20px">
            {isEditing ? '編輯公司資料' : '新增公司資料'}
          </Box>
        </Box>

        <VStack spacing={4} align="stretch" mb={5}>
          <FormControl isRequired>
            <FormLabel>公司名稱</FormLabel>
            <Input
              value={companyInfo.company_name}
              onChange={(e) => handleChange('company_name', e.target.value)}
              placeholder="請輸入公司名稱"
            />
          </FormControl>

          <FormControl>
            <FormLabel>電話</FormLabel>
            <Input
              value={companyInfo.company_tel}
              onChange={(e) => handleChange('company_tel', e.target.value)}
              placeholder="請輸入公司電話"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>地址</FormLabel>
            <Input
              value={companyInfo.company_address}
              onChange={(e) => handleChange('company_address', e.target.value)}
              placeholder="請輸入公司地址"
            />
          </FormControl>
        </VStack>

        <div className="button-group">
          <Button
            variant="outline"
            onClick={onCancel}
            mr={3}
          >
            取消
          </Button>
          <Button
            colorScheme="green"
            bg="#1C734A"
            onClick={onSubmit}
            isLoading={isLoading}
          >
            {isEditing ? '更新' : '新增'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompanyFormModal;
